import { render, staticRenderFns } from "./ItemCart.vue?vue&type=template&id=a706aeba&scoped=true&"
import script from "./ItemCart.vue?vue&type=script&lang=js&"
export * from "./ItemCart.vue?vue&type=script&lang=js&"
import style0 from "./ItemCart.vue?vue&type=style&index=0&id=a706aeba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a706aeba",
  null
  
)

export default component.exports